import {webResponseObject} from "./webResponseResponse";
import axios from "axios";
import {applyooConfig} from "../js/applyooConfig";
import {store} from "../../redux/storeConfig/store";
import {handleLogin} from "../../redux/actions/auth";
import {utils_log} from "../utils/utils_log";
import {sendApplyooComponentsNotification} from "../infrastructure/useApplyooComponent";


// export const callService_GetJsGlobals = async (prmParamsObj: any) => {
//     return callPostService("JsGlobals_GetJsGlobals",prmParamsObj)
//         .then((prmResponse:any) => {
//         let loginInfo = prmResponse.reponseObj;
//     })
// }

export const callService_GetLoginDetails = async (prmProjectID:number) => {
    return callPostService("GetLoginDetails",{"prmProjectID" : "1057"}).then((prmResponse:webResponseObject) => {
        let loginInfo = prmResponse;
    })
}

export const callGetService = async (prmUrl: string, prmParamsObj?: any) => {
    const headers = {
        'token': localStorage["AccessToken"]
    }

    axios.get(prmUrl, {
        headers: headers
    })
    .then(response => {
        return response;
    });
}

export const refreshJwtToken= async () => {
    utils_log.writeToLog("refreshJwtToken!!")
    const serviceURL = `${applyooConfig.API_URL}/applyoo/RefreshToken`;

    const headers = {
        'Content-Type': 'application/json',
        'token': localStorage["AccessToken"]
    }

    const paramsObj = {
        'RefreshToken': localStorage["RefreshToken"],
        'AccessToken': localStorage["AccessToken"],
    }

    let resp =await axios.post(serviceURL, paramsObj, {
        headers: headers
    })
        .then((response) => {
            let outObj = null;

            if (!response){
                utils_log.writeToLog("refreshJwtToken Has No Response!!")
                // store.dispatch({type:'SESSION_EXPIRED'})
                // localStorage.setItem('userData','')
                // window.open(applyooConfig.loginPath)

                //sendApplyooComponentsNotification("ApplyooGlobal", "ProjectFrameContainer", {command: "navigateToUrl", "urlStr": '/login'})
                // history.replaceState(null,"",'/logout');
            }
            else if (!!response.data){
                utils_log.writeObjectToLog("refreshJwtToken Response", response.data)

                if (!response.data.IsAuthenticated){
                    store.dispatch({type:'SESSION_EXPIRED'})
                    // localStorage.setItem('userData','')
                    //sendApplyooComponentsNotification("ApplyooGlobal", "ProjectFrameContainer", {command: "navigateToUrl", "urlStr": '/login'})
                    // window.open(applyooConfig.loginPath)
                    // history.replaceState(null,"",'/logout');

                }
                else {
                    let resObj = response.data;

                    localStorage.setItem(applyooConfig.jwtLogin.storageTokenKeyName, resObj.AccessToken) //JSON.stringify(data.accessToken))
                    localStorage.setItem(applyooConfig.jwtLogin.storageRefreshTokenKeyName, resObj.RefreshToken) //JSON.stringify(data.refreshToken))

                    // const data = { data: resObj, AccessToken: resObj.AccessToken, RefreshToken: resObj.RefreshToken }
                    // store.dispatch(handleLogin(data))
                    return resObj;
                }
            }

            return outObj;

        })
        .catch((error) => {
            console.log('error calling ' + serviceURL, error,paramsObj);

            store.dispatch({type:'SESSION_EXPIRED'})
            // localStorage.setItem('userData','')
            // sendApplyooComponentsNotification("ApplyooGlobal", "ProjectFrameContainer", {command: "navigateToUrl", "urlStr": '/login'})
            // history.replaceState(null,"",'/logout');
            // window.open(applyooConfig.loginPath)
        })

}

export const callPostService = async (prmWebMethod: string, prmParamsObj?: any) => {
    let serviceURL = `${applyooConfig.API_URL}/applyoo/${prmWebMethod}`;

    if (!!prmParamsObj.isSpecificMethodUrl){
        serviceURL = prmWebMethod;
    }

    const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': window.location.origin,
        'Access-Control-Allow-Credentials': 'true',
        // 'Access-Control-Allow-Origin': '*',
        //'Authorization': 'JWT',
        'token': localStorage["AccessToken"]
    }

    utils_log.writeToLog(`***callPostService - ${prmWebMethod} - Start`)

    let resp =await axios.post(serviceURL, prmParamsObj, {
        headers: headers
    })
        .then((response) => {
            let outObj = null;

            utils_log.writeToLog(`***callPostService - ${prmWebMethod} - Response`)

            if (!!response?.data){
                if (!response.data.isInSession){
                    if (!!localStorage["RefreshToken"]){
                        refreshJwtToken().then((response:any) => {
                            // if (!!response.data) {
                            //     callPostService(prmWebMethod,prmParamsObj);
                            // }
                            // else {
                            //     store.dispatch({type:'SESSION_EXPIRED'})
                            //     history.pushState(null,"",'/login');
                            // }
                        })
                    }
                    else {
                        store.dispatch({type:'SESSION_EXPIRED'});
                        store.dispatch({type:'NAVIGATE', currentLocation:'/logout'});
                    }

                    // dispatch({type:'LOGIN_SUCCEED', LoginToken:loginResponse.dataStr})
                    // history.pushState(null,"",'/pages/login-v1');
                }
                else {
                    outObj = response.data;
                }
            }
            // else {
            //     store.dispatch({type:'SESSION_EXPIRED'});
            //     store.dispatch({type:'NAVIGATE', currentLocation:'/logout'});
            // }

            return outObj;
            // dispatch({
            //     type: FOUND_USER,
            //     data: response.data[0]
            // })
        })
        .catch((error:any) => {
            console.log('error calling ' + serviceURL, error,prmParamsObj);
        })

    // let resp = await fetch(serviceURL, {
    //     method: "POST",
    //     body: JSON.stringify(prmParamsObj),
    //     headers: {
    //         'content-type': 'application/json',
    //         'Accept': 'application/json',
    //     }
    // })
     let data = await resp; //.json()
    // //console.log("service say:" ,data)
     return data;
}

axios.interceptors.response.use(undefined, function (error: any) {
    // if (error.response.status == 401){
    //     localStorage['userData'] =''
    //     localStorage['AccessToken'] =''
    //
    // }

    // console.log(error)
    // //(error as any).originalMessage = error.message;
    // Object.defineProperty(error, "message", { get: function () {
    //         // if (!error.response) {
    //         //     return (error as any).originalMessage;
    //         // }
    //         //return JSON.stringify(error.response.data);
    //     }});
    // return Promise.reject(error);
})

export const callPostServiceByUrl = async (prmUrlStr: string, prmParamsObj?: any) => {
    //const serviceURL = `${applyooConfig.baseServiceURL}${prmWebMethod}`;

    const headers = {
        //'Content-Type': 'application/json',
        // 'Access-Control-Allow-Origin': '*',
        //'Authorization': 'JWT',
        'token': localStorage["AccessToken"]
    }

    let resp =await axios.post(prmUrlStr, prmParamsObj, {
        headers: headers,
        onUploadProgress: progressEvent => {
            let percentCompleted = !!progressEvent?.total ? Math.round((progressEvent.loaded * 100) / progressEvent?.total) : 0
            utils_log.writeToLog(percentCompleted)
            //console.log(progressEvent.loaded)
        }
    })
        .then((response) => {
            let outObj = null;

            if (!!response?.data){
                if (!response?.data?.isInSession){
                }
                else {
                    outObj = response.data;
                }
            }

            return outObj;
        })
        .catch((error) => {
            console.log('error calling ' + prmUrlStr, error,prmParamsObj);
        })

    let data = await resp; //.json()

    return data;
}


